import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import FormInput from 'components/FormInput'
import {Field, reduxForm, SubmissionError, reset, blur} from 'redux-form'
import ButtonsGroup from 'components/ButtonsGroup'
import OrdersList from './OrdersList'
import {
  fetchOrdersById
} from 'redux/modules/orders/actions'
import {
  getOrdersById,
  getSelectedGroups
} from 'redux/modules/orders/selectors'
import {channelGroups} from '@divvit/common-channels'
import classnames from 'classnames'

export class OrdersInsightFindView extends React.Component {
  static propTypes = {
    orders: PropTypes.array,
    isOrdersFetching: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    reset: PropTypes.func,
    blur: PropTypes.func,
    selectedGroups: PropTypes.object
  }

  render() {
    const {
      orders,
      isOrdersFetching,
      selectedGroups,
      handleSubmit,
      submitting,
      invalid
    } = this.props

    return (
      <div className='orders-view'>
        <div className='orders-view_form'>
          <div className='orders-view_form_header'>
            <div className='orders-view_form_header_title'>
              Conversion Id - <span className='orders-view_form_header_hint'>Separate with comma</span>
            </div>
            <div className='orders-view_form_header_reset' onClick={this.onReset}>Reset</div>
          </div>
          <div className='orders-view_form_body'>
            <form onSubmit={handleSubmit} className='orders-view_form_body_fields'>
              <Field
                name='ids'
                disabled={submitting}
                autoFocus
                component={FormInput}
              />
              <ButtonsGroup align='right'>
                <button type='submit' disabled={submitting || invalid}>Search</button>
              </ButtonsGroup>
            </form>
          </div>
        </div>
        <OrdersList
          orders={orders}
          loading={isOrdersFetching}
          selectedGroups={selectedGroups}
        />
        <div className='orders-view_legend'>
          <div className='orders-view_legend_column'>
            {this.renderGroup('direct')}
            {this.renderGroup('unknown')}
          </div>
          <div className='orders-view_legend_column'>
            {this.renderGroup('email')}
            {this.renderGroup('referral')}
          </div>
          <div className='orders-view_legend_column'>
            {this.renderGroup('organic')}
            {this.renderGroup('sem')}
          </div>
          <div className='orders-view_legend_column'>
            {this.renderGroup('social_organic')}
            {this.renderGroup('social_ppc')}
          </div>
          <div className='orders-view_legend_column'>
            {this.renderGroup('retargeting')}
            {this.renderGroup('display')}
            {this.renderGroup('affiliate')}
            {this.renderGroup('onsite')}
          </div>
        </div>
      </div>
    )
  }

  renderGroup(name) {
    if (!channelGroups[name]) {
      return ''
    }

    const {label} = channelGroups[name]

    const classNames = classnames('orders-view_legend_group', {
      [`is-${name}`]: true
    })

    return (
      <div className={classNames} key={name}>
        {label}
      </div>
    )
  }

  onReset = event => {
    const {reset, blur} = this.props

    reset('searchOrders')
    blur()
  }
}

const mapStateToProps = state => {
  return {
    orders: getOrdersById(state),
    isOrdersFetching: state.orders.listByIdsFetching,
    selectedGroups: getSelectedGroups(state)
  }
}

export default connect(mapStateToProps, {
  reset, blur
})(reduxForm({
  form: 'searchOrders',
  validate: ({ids}) => {
    const errors = {}

    if (!ids) {
      errors.ids = 'Please provide one or more conversion ids'
    }

    return errors
  },
  onSubmit: ({ids}, dispatch) => new Promise((resolve, reject) => {
    const idArray = ids.split(/[\s,;]+/).filter(Boolean)
    dispatch(fetchOrdersById(idArray))
      .success(resolve)
      .fail(err => {
        reject(new SubmissionError({_error: err.message}))
      })
  })
})(OrdersInsightFindView))



// WEBPACK FOOTER //
// ./client/views/OrdersInsightView/OrdersInsightFindView.js